import { InstitutionOptionModelDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../../../shared';

export class InstitutionOptionModel extends DomainEntity<InstitutionOptionModelDto> {
    public createDefault(): this {
        throw new Error('Method not implemented.');
    }

    public get name() {
        return this.dto.name;
    }

    public get value() {
        return this.dto.value;
    }
}
